import { render, staticRenderFns } from "./PaginationBlock.vue?vue&type=template&id=321a0a62"
import script from "./PaginationBlock.vue?vue&type=script&lang=js"
export * from "./PaginationBlock.vue?vue&type=script&lang=js"
import style0 from "./PaginationBlock.vue?vue&type=style&index=0&id=321a0a62&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports